import React from 'react';
import { usePermissions } from 'app/contexts/PermissionsContext';
import Tooltip from 'shared/components/andtComponents/Tooltip';
import { ACCOUNT_FEATURES } from 'users/constants/usersConstants';
import { useRootStore } from 'app/contexts/RootStoreContext';
import checkFeatureFlag from '../utils/featureFlagUtil';
import { observer } from 'mobx-react';

// eslint-disable-next-line react-refresh/only-export-components
const ReadOnlyDisplayWrapperComponent = ({
  isHide = true,
  children,
  category,
  action,
  oneOfCategoryActionList,
  legacyUserTypeList,
  block = false,
}) => {
  const { isHasPermission } = usePermissions();

  const disabledStyle = { pointerEvents: 'none', opacity: '0.4' };
  const hideStyle = { display: 'none' };
  const { usersStore } = useRootStore();
  const showDebugTooltip = checkFeatureFlag(usersStore, ACCOUNT_FEATURES.PERMISSION_TOOLTIP_DEBUG);

  const getIsPermissionBlocked = () => {
    if (block) {
      return false;
    }
    if (!oneOfCategoryActionList) {
      return !isHasPermission(category, action, legacyUserTypeList);
    } else if (Array.isArray(oneOfCategoryActionList)) {
      return oneOfCategoryActionList.some(
        (categoryAction) => !isHasPermission(categoryAction.category, categoryAction.action, legacyUserTypeList),
      );
    }
  };

  const getStyle = () => {
    let style = {};
    if (getIsPermissionBlocked()) {
      style = isHide ? hideStyle : disabledStyle;
    }
    return style;
  };

  const getTooltipTitle = () => {
    if (!oneOfCategoryActionList) {
      return `Permission: ${category}:${action}`;
    } else {
      return `Permission: ${oneOfCategoryActionList.map(
        (categoryAction) => `${categoryAction.category}:${categoryAction.action}`,
      )}`;
    }
  };

  return (
    <Tooltip placement="left" title={getTooltipTitle()} disabled={!showDebugTooltip}>
      <div style={getStyle()}>{children}</div>
    </Tooltip>
  );
};


const ReadOnlyDisplayWrapper = observer(ReadOnlyDisplayWrapperComponent);
export default ReadOnlyDisplayWrapper;
